import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itoohavetalent22',
  templateUrl: './itoohavetalent22.component.html',
  styleUrls: ['./itoohavetalent22.component.scss']
})
export class Itoohavetalent22Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
